// extracted by mini-css-extract-plugin
export default {"link":"mQ-z","disabled":"nQ-z"};